<template>
  <div>
    <dv-border-box-7>

      <div class="bg-color-black" style="height: 100%;">
        <div class="d-flex pt-2 pl-2" style="height:20px;">
          <div style="font-size:16px;color:#5cd9e8;float:left;padding:5px"> 各类型交易量对比
            <dv-decoration-1 style="width:1.25rem;height:.15rem; position:relative;top:-.0375rem;" />
          </div>

        </div>
        <div id="chart5" style="width:98%;margin-left:2%;height:90%">

        </div>

      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {


  },
  mounted() {
    this.showData();
  },
  methods: {
    showData() {
      this.$http.get("/web/tradeData?unitCode=" + localStorage.getItem("unitCode"))
        .then((
          res) => {
          var names = [];
          var values = [];
          for (var i = 0; i < res.data.data.tradeTypeNumList.length; i++) {
            var type = "";
            switch (res.data.data.tradeTypeNumList[i].type) {
              case 1: type = "土地经营权"; break;
              case 2: type = "集体资产"; break;
              case 3: type = "集体建设地"; break;
              case 4: type = "涉农项目"; break;
              case 5: type = "股权"; break;
              case 6: type = "宅基地"; break;
              case 7: type = "农民住房"; break;
              case 8: type = "养殖水面"; break;
              case 9: type = "林地林木"; break;
              case 10: type = "设施设备"; break;
              case 11: type = "采购"; break;
              case 12: type = "竞争性磋商"; break;
              case 13: type = "公开招标"; break;
            }
            names.push(type);
            values.push({ "name": type, "value": res.data.data.tradeTypeNumList[i].amount });
          }
          this.chart_pie('chart5', names, values)

        });

    },
    chart_pie(id, names, values) {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          left: 'center',
          top: 'bottom',
          data: names,
          textStyle: {
            color: "#ffffff"
          }
        },
        textStyle: {
          color: "#ffffff"
        },
        series: [
          {
            name: '各类型交易量对比',
            type: 'pie',
            radius: [30, 80],
            center: ['45%', '50%'],
            roseType: 'radius',
            itemStyle: {
              borderRadius: 5,
            },

            label: {
              show: true,
              color: "#ffffff",
            },
            emphasis: {
              label: {
                show: true
              }
            },
            data: values
          },
        ],
        color: ['#60a786', '#67e0e3', '#96bfff', '#37a2da', '#32c5e9', '#9fe6b8']

      };
      var myChart = echarts.init(document.getElementById(id));
      myChart.setOption(option);



      var index = 0; //播放所在下标
      var that = this;
      var mTime = setInterval(function () {
        myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: index
        });
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: index
        });
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        if (index > names.length-1) {
          index = 0;
        }
      }, 1000)


      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
  data() {
    return {
      timer: null,
      day: '',
      hr: '',
      min: '',
      sec: ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
